/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'
import talhaImg from '../assets/images/talha.png'
import asadIrshad from '../assets/images/asad-irshad.png'
import noumanIjaz from '../assets/images/nouman-ijaz.png'





export const testimonialsData = [
   {
    id: 1,
    name: 'Nouman Ijaz',
    title: 'Full Stack Engineer',
    text: "Talha is a quick learner and always finds smart solutions to problems. Working with him has been a great experience.",
    image: noumanIjaz
},
{
    id: 2,
    name: 'Asad Irshad',
    title: 'Full Stack Developer',
    text: "Dedicated and reliable, Talha never settles for average. His coding standards and attention to detail make him stand out.",
    image: asadIrshad
},

    {
        id: 3,
        name: 'Phoebe Buffay',
        title: 'Massuese',
        text: "Heard of the song 'Smelly Cat!!' ? This website made it viral. Plus portfolio is the only thing that Ursula doesn't have :)",
        image: girl1
    },
    {
        id: 4,
        name: 'Joey Tribbiani',
        title: 'Actor',
        text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
        image: boy1
    },
    {
        id: 5,
        name: 'Rachel Green',
        title: 'Sales Executive',
        text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
        image: girl3
    },
    {
        id: 6,
        name: 'Ross Geller',
        title: 'Paleontologist',
        text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
        image: boy3
    }
]

